import { all, fork, put, takeLatest } from 'redux-saga/effects';
import * as types from './types';
import * as Api from '../../api/concreteClasses';
import callToAPI from '../../../utils/callToAPI';

function* getConcreteClassesStatistical({ payload }) {
  yield callToAPI({
    apiCall: Api.getConcreteClassesStatistical,
    successResponseCode: 200,
    errorType: types.GET_CONCRETE_CLASSES_STATISTICAL_ERROR,
    *callback({ data }) {
      yield put({
        type: types.GET_CONCRETE_CLASSES_STATISTICAL_SUCCESS,
        payload: {
          data: data.data || data,
          total: data.total || (data.data || data).length,
        },
      });
    },
    payload,
  });
}

function* watchGetConcreteClassesStatistical() {
  yield takeLatest(
    types.GET_CONCRETE_CLASSES_STATISTICAL_REQUEST,
    getConcreteClassesStatistical,
  );
}

export default function* rootSaga() {
  yield all([fork(watchGetConcreteClassesStatistical)]);
}
